import { useReminderHook } from "@/hooks/use-reminder.hook.ts";
import { ReminderPeriod } from "@/types/reminder.types.ts";
import { Button, Modal, ModalProps, Select, Stack, Text, useModals } from "@skailer-com/uikit";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export interface EsignReminderCustomModalProps extends ModalProps {
  frequency: number;
  period: ReminderPeriod;
  onSave: (frequency: number, period: ReminderPeriod) => void;
}

export function EsignReminderCustomModal({
  frequency,
  period,
  onSave,
  ...props
}: EsignReminderCustomModalProps) {
  const { t } = useTranslation();
  const { close } = useModals();
  const { getReminderPeriodTitle } = useReminderHook();
  const { id } = props;

  const [freq, setFreq] = useState(frequency);
  const [per, setPer] = useState<ReminderPeriod>(period);

  return (
    <Modal
      {...props}
      title={t("core:esign_reminder_custom_title")}
      withCloser={true}
      actions={
        <Stack gap={"sm"}>
          <Button
            size={"lg"}
            onClick={() => {
              onSave(freq, per);
              close(id);
            }}
          >
            {t("common:save")}
          </Button>
          <Button variant={"plain"} size={"md"} onClick={() => close(id)}>
            {t("common:cancel")}
          </Button>
        </Stack>
      }
    >
      <Stack direction={"horizontal"} gap={"sm"} items={"center"}>
        <Text>{t("core:esign_remind_every")}</Text>
        <Select
          variant={"button"}
          emptyTitle={t("common:period")}
          value={String(freq)}
          onChange={(value) => setFreq(Number(value))}
          options={Array.from({ length: 30 }, (_, index) => ({
            id: String(index + 1),
            title: String(index + 1),
          }))}
        />
        <Select
          key={`period-${freq}`}
          variant={"button"}
          emptyTitle={t("common:period")}
          value={per}
          onChange={(value) => setPer(value as ReminderPeriod)}
          options={[
            { id: ReminderPeriod.day, title: getReminderPeriodTitle(ReminderPeriod.day, freq) },
            { id: ReminderPeriod.week, title: getReminderPeriodTitle(ReminderPeriod.week, freq) },
            { id: ReminderPeriod.month, title: getReminderPeriodTitle(ReminderPeriod.month, freq) },
          ]}
        />
      </Stack>
    </Modal>
  );
}
